<template>
  <div>
    <el-card>
      <el-form ref="filter" :model="filter" inline size="small" label-width="100px">
        <el-form-item label="姓名">
          <el-input v-model="filter.name" placeholder="请输入姓名" clearable />
        </el-form-item>
        <el-form-item label="毕业院校">
          <el-input v-model="filter.graduateSchool" placeholder="请输入毕业院校" clearable />
        </el-form-item>
        <el-form-item label="毕业时间">
          <my-datePicker :scopeDate="graduateDate" @receiveMyDate="receiveGraduateDate" />
        </el-form-item>
        <el-form-item label="常驻地">
          <el-cascader
            ref="areaCascader"
            v-model="filterAddress"
            clearable
            :options="options"
            :props="props"
            @change="changeFilterAddress"
          />
        </el-form-item>
        <el-form-item label-width="120px" label="">
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-row>
        <el-button type="primary" size="small" @click="toEditCommunicationConf">配置交流账号</el-button>
      </el-row>
      <br>
      <el-table :data="tableData" border>
        <el-table-column align="center" label="姓名" prop="name" min-width="120px" :formatter="fliteRData" />
        <el-table-column align="center" label="手机号" prop="phone" min-width="120px" :formatter="fliteRData" />
        <el-table-column align="center" label="毕业时间" prop="graduateDate" min-width="120px" :formatter="fliteRData" />
        <el-table-column align="center" label="毕业院校" prop="graduateSchool" min-width="140px" :formatter="fliteRData" />
        <el-table-column align="center" label="工作单位" prop="workCompany" min-width="140px" :formatter="fliteRData" />
        <el-table-column align="center" label="常驻地" min-width="200px">
          <template v-slot="{ row }">
            <span>{{ row.provinceName}}{{ row.cityName}}{{ row.areaName}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="运营账号名称" prop="accName" min-width="120px" :formatter="fliteRData" />
        <el-table-column align="center" label="运营账号地址" prop="accLink" min-width="200px" :formatter="fliteRData" />
        <el-table-column align="center" label="运营账号粉丝量/千" prop="accFansNum" min-width="140px" :formatter="fliteRData" />
        <el-table-column align="center" label="操作" min-width="200px" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="toEdit(row)">编辑</el-button>
            <el-button type="text" size="mini" @click="toViewResume(row)">个人简历</el-button>
            <el-button type="text" size="mini" @click="toViewCertificate(row)">培训经历/所获证书</el-button>
            <el-button type="text" size="mini" @click="toViewRecord(row.id)">修改记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageInfo.page" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    </el-card>
    <!-- 配置交流账号 -->
    <el-dialog
      title="配置交流账号"
      :visible.sync="dialogCommunicationConfVisable" width="540px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleCloseCommunicationConfDialog"
    >
      <el-form
        ref="formEl"
        :model="communicationConfForm"
        :rules="rules"
        label-width="120px"
        size="small"
      >
        <el-form-item label="上传图片：" prop="img">
          <PictureUpload v-model="communicationConfImg" :limit="1" />
          <p class="form-tips">可上传jpg、png格式图片，最大不超过2M</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="saveing" size="small" type="primary" @click="handleCommunicationConf">保存</el-button>
        <el-button size="small" @click="handleCloseCommunicationConfDialog">取消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      title="编辑"
      :visible.sync="dialogEditVisable" width="640px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleCloseEditDialog"
    >
      <el-form ref="editFormEl" :model="editForm" :rules="rules" size="small" label-width="120px">
        <el-form-item label="姓名: " prop="name">
          <p>{{ editForm.name }}</p>
        </el-form-item>
        <el-form-item label="手机号: " prop="phone">
          <p>{{ editForm.phone }}</p>
        </el-form-item>
        <el-form-item label="毕业时间: " prop="graduateDate">
          <el-date-picker
            v-model="editForm.graduateDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择毕业时间"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="毕业院校: " prop="graduateSchool">
          <el-input v-model="editForm.graduateSchool" placeholder="请输入毕业院校" clearable maxlength="50"/>
        </el-form-item>
        <el-form-item label="工作单位: " prop="workCompany">
          <el-input v-model="editForm.workCompany" placeholder="请输入工作单位" clearable maxlength="100"/>
        </el-form-item>
        <el-form-item label="职业: " prop="occupation">
          <el-input v-model="editForm.occupation" placeholder="请输入职业" clearable maxlength="100"/>
        </el-form-item>
        <el-form-item label="常驻地: " prop="provinceCode">
          <el-cascader
            ref="areaCascader"
            v-model="formAddress"
            :options="options"
            :props="props"
            style="width:100%"
            @change="changeFormAddress"
          />
        </el-form-item>
        <el-form-item label="运营账号名称: " prop="accName">
          <el-input v-model="editForm.accName" placeholder="请输入运营账号名称" clearable maxlength="100"/>
        </el-form-item>
        <el-form-item label="运营账号地址: " prop="accLink">
          <el-input v-model="editForm.accLink" placeholder="请输入运营账号地址" clearable maxlength="100"/>
        </el-form-item>
        <el-form-item label="运营账号粉丝量: " prop="accFansNum">
          <el-input v-model="editForm.accFansNum" placeholder="请输入运营账号粉丝量" clearable maxlength="100">
            <template slot="append">千</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="handleCloseEditDialog">取消</el-button>
        <el-button type="primary" size="small" @click="submitEdit">确定</el-button>
      </div>
    </el-dialog>
    <!-- 培训经历/所获证书 -->
    <el-dialog
      :title="detailTitle"
      :visible.sync="dialogDetailVisable" width="640px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleCloseDetailDialog"
    >
      <el-row type="flex" class="info-line" align="middle">
        <p class="label">姓名: </p>
        <p class="value">{{ detail.name }}</p>
      </el-row>
      <el-row type="flex" class="info-line" align="middle">
        <p class="label">手机号: </p>
        <p class="value">{{ detail.phone }}</p>
      </el-row>
      <el-row v-if="detail.type === 1" type="flex" class="info-line" align="middle">
        <p class="label">个人简历: </p>
        <el-button v-if="detail.resume" type="primary" size="small" @click="openDoc(detail.resume)">下载附件</el-button>
        <span v-else>暂无</span>
      </el-row>
      <template v-else-if="detail.type === 2">
        <template v-if="detail.trainCertList">
          <el-row v-for="(item, index) of detail.trainCertList" :key="item" type="flex" class="info-line" align="middle">
            <p class="label">证书附件{{ index > 0 ? index + 1 : '' }}: </p>
            <el-button type="primary" size="small" @click="openDoc(item)">下载附件</el-button>
          </el-row>
        </template>
        <el-row v-else type="flex" class="info-line" align="middle">
          <p class="label">证书附件: </p>
          <span>暂无</span>
        </el-row>
      </template>
      <div slot="footer">
        <el-button size="small" @click="handleCloseDetailDialog">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 修改记录 -->
    <Record ref="RecordEl" />
  </div>
</template>

<script>
import tableMoudel from "@/libs/mixins/table"
import PictureUpload from "@/components/pictureUpload.vue"
import Record from "./record.vue";
import myDatePicker from "@/components/myDatePicker.vue"
import { cityJSON } from "@/utils/cityJson.js";
import { getTalentPoolListPage, updateTalentPoolInfo, getCommunicationConf, updateCommunicationConf } from "@/api/product/base"

export default {
  mixins: [tableMoudel],
  components: { PictureUpload, Record, myDatePicker },
  data () {
    return {
      filter: {
        name: null,
        graduateSchool: null,
        graduateDateStart: null,
        graduateDateEnd: null,
        provinceCode: null,
        cityCode: null,
        areaCode: null,
      },
      graduateDate: [],
      filterAddress: [],
      props: {
        value: "code",
        label: "name",
        children: "cityList",
      },
      options: [],
      tableData: [],
      saveing: false,
      dialogCommunicationConfVisable: false,
      communicationConfForm: {
        img: ''
      },
      communicationConfImg: [],
      dialogEditVisable: false,
      editForm: {
        name: '',
        phone: '',
        graduateDate: '',
        graduateSchool: '',
        workCompany: '',
        occupation: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        areaCode: '',
        areaName: '',
        accName: '',
        accLink: '',
        accFansNum: '',
      },
      formAddress: [],
      rules: {
        img: [
          { required: true, message: "请上传图片!", trigger: "blur" },
        ],
        graduateDate: [{ required: true, message: '请选择毕业时间', trigger: 'change' }],
        graduateSchool: [{ required: true, message: '请输入毕业院校', trigger: 'blur' }],
        workCompany: [{ required: true, message: '请输入工作单位', trigger: 'blur' }],
        occupation: [{ required: true, message: '请输入职业', trigger: 'blur' }],
        provinceCode: [{ required: true, message: '请选择常驻地', trigger: 'change' }],
        accName: [{ required: true, message: '请输入运营账号名称', trigger: 'blur' }],
      },
      detailTitle: '',
      dialogDetailVisable: false,
      detail: {}
    }
  },
  created () {
    this.getData()
    const a = JSON.stringify(cityJSON)
    const t = a.replaceAll('areaList', 'cityList')
    this.options = JSON.parse(t)
  },
  methods: {
    reset () {
      this.pageInfo.page = 1
      this.graduateDate = []
      this.filterAddress = []
      this.filter = this.$options.data().filter
      this.getData()
    },
    async getData () {
      const params = {
        ...this.pageInfo,
        ...this.filter
      }
      const res = await getTalentPoolListPage(params)
      const { records, total } = res.data
      this.total = Number(total)
      this.tableData = records
    },
    // 点击配置交流账号
    toEditCommunicationConf () {
      getCommunicationConf().then(({ code, data }) => {
        if (code === 0) {
          this.communicationConfForm.id = data.id
          if (data.img) {
            this.communicationConfForm.img = data.img
            this.communicationConfImg = [{ url: data.img }]
          }
        }
      })
      this.dialogCommunicationConfVisable = true
    },
    handleCommunicationConf () {
      this.$refs.formEl.validate(valid => {
        if (valid) {
          this.saveing = true
          updateCommunicationConf(this.communicationConfForm).then(({ code }) => {
            if (code === 0) {
              this.$message.success('配置交流账号成功!')
              this.handleCloseCommunicationConfDialog()
            }
          }).finally(() => {
            this.saveing = false
          })
        }
      })
    },
    // 编辑
    toEdit (row) {
      this.editForm.id = row.id
      this.editForm.name = row.name
      this.editForm.phone = row.phone
      this.editForm.graduateDate = row.graduateDate
      this.editForm.graduateSchool = row.graduateSchool
      this.editForm.workCompany = row.workCompany
      this.editForm.occupation = row.occupation
      this.editForm.provinceCode = row.provinceCode
      this.editForm.provinceName = row.provinceName
      this.editForm.cityCode = row.cityCode
      this.editForm.cityName = row.cityName
      this.editForm.areaCode = row.areaCode
      this.editForm.areaName = row.areaName
      this.editForm.accName = row.accName
      this.editForm.accLink = row.accLink
      this.editForm.accFansNum = row.accFansNum
      this.formAddress = [row.provinceCode, row.cityCode, row.areaCode]
      this.dialogEditVisable = true
    },
    // 提交编辑
    submitEdit () {
      this.$refs.editFormEl.validate(valid => {
        if (valid) {
          updateTalentPoolInfo(this.editForm).then(({ code }) => {
            if (code === 0) {
              this.$message.success('修改成功!')
              this.getData()
              this.handleCloseEditDialog()
            }
          })
        }
      })
    },
    // 个人简历
    toViewResume (row) {
      this.detailTitle = '个人简历'
      this.detail = {
        name: row.name || '--',
        phone: row.phone || '--',
        resume: row.resume || '',
        type: 1
      }
      this.dialogDetailVisable = true
    },
    openDoc (url) {
      window.open(url)
    },
    // 培训经历/所获证书
    toViewCertificate (row) {
      this.detailTitle = '培训经历/所获证书'
      this.detail = {
        name: row.name || '--',
        phone: row.phone || '--',
        type: 2
      }
      if (row.trainCert) {
        this.$set(this.detail, 'trainCertList', row.trainCert.split(','))
      }
      this.dialogDetailVisable = true
    },
    // 修改记录
    toViewRecord (id) {
      this.$refs.RecordEl.init(id)
    },
    receiveGraduateDate (val) {
      this.graduateDate = val
      this.filter.graduateDateStart = val[0] + ' 00:00:00'
      this.filter.graduateDateEnd = val[1] + ' 23:59:59'
    },
    handleCloseEditDialog () {
      this.editForm = this.$options.data().editForm
      this.formAddress = []
      this.$refs.editFormEl && this.$refs.editFormEl.resetFields
      this.dialogEditVisable = false
    },
    handleCloseDetailDialog () {
      this.detail = this.$options.data().detail
      this.dialogDetailVisable = false
    },
    handleCloseCommunicationConfDialog () {
      this.communicationConfForm = this.$options.data().communicationConfForm
      this.communicationConfImg = []
      this.dialogCommunicationConfVisable = false
    },
    changeFilterAddress (val) {
      // const l = this.$refs['areaCascader'].getCheckedNodes()[0].pathLabels
      this.filter.provinceCode = val[0]
      this.filter.cityCode = val[1]
      this.filter.areaCode = val[2]
    },
    changeFormAddress (val) {
      const l = this.$refs['areaCascader'].getCheckedNodes()[0].pathLabels
      this.editForm.provinceCode = val[0]
      this.editForm.provinceName = l[0]
      this.editForm.cityCode = val[1]
      this.editForm.cityName = l[1]
      this.editForm.areaCode = val[2]
      this.editForm.areaName = l[2]
    }
  },
  watch: {
    communicationConfImg: {
      handler (val) {
        if (val && val.length) {
          const t = val.map(item => item.url)
          this.communicationConfForm.img = t.join(',')
          this.$nextTick(() => {
            this.$refs.formEl.clearValidate('img')
          })
        } else {
          this.communicationConfForm.img = ''
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.info-line {
  padding: 6px 0;
  .label {
    width: 120px;
    text-align: right;
    font-size: 14px;
    color: #666;
    margin-right: 18px;
  }
}
.form-tips {
  font-size: 12px;
  color: #999;
}
</style>
